import lodash from "lodash";

export const getAgencySetting = (state) => {
    return lodash.get(state, 'deliveryNote.deliveryNotePrint.agencySetting');
};

export const getSetting = (state) => {
    return lodash.get(state, 'deliveryNote.deliveryNotePrint.setting');
};